export default "__VITE_ASSET__1KF4E_22__"